<template>
    <q-card class="q-pa-md main" inline>
        <QCardMain>

            <div class="row">
                <div class="col q-mr-md">
                    <q-field label="Nazwa" label-width="3">
                        <q-input type="text" v-model="model.label"/>
                    </q-field>

                    <div>
                        <drop-area @dropped="setThumbUrl" style="position: relative; ">
                            <div v-if="!model.thumbUrl">Upuść obraz</div>
                            <image-viewer :src="model.thumbUrl" v-if="model.thumbUrl" />

                            <q-btn
                                v-if="model.thumbUrl"
                                icon="delete"
                                dense
                                flat
                                class="absolute-top-right"
                                style="right: 0px; top: 10px; z-index: 10"
                                @click="model.thumbUrl = ''"/>
                        </drop-area>
                    </div>

                    <q-field label="Opis przed osiągnięciem" label-width="4">
                        <q-input type="textarea" v-model="model.description"/>
                    </q-field>
                    <q-field label="Opis po osiągnięciu" label-width="4">
                        <q-input type="textarea" v-model="model.descriptionWhenAchieved"/>
                    </q-field>
                </div>

                <div class="col">
                    <div class="text-grey-8">
                        Żeby zdobyć to osiągnięcie należy zdobyć wszystkie poniższe rzeczy.<br>

                        <a v-if="!published" href="#" @click.prevent="addCounter">Dodaj licznik</a>

                        <div class="row" v-for="(c, index) in counters" :key="index">
                            <div class="col q-mr-md">
                                <q-field>
                                    <q-select
                                        :disable="published"
                                        @input="updateCounters"
                                        placeholder="Licznik"
                                        v-model="c.id"
                                        inline
                                        :options="allCounters"
                                    />
                                </q-field>
                            </div>
                            <div class="col">
                                <q-field>
                                    <q-input
                                        :readonly="published"
                                        :disable="published"
                                        @input="updateCounters"
                                        placeholder="Min wartość"
                                        type="number"
                                        v-model="c.value"
                                        inline
                                    />
                                </q-field>
                            </div>

                            <q-btn
                                v-if="!published"
                                icon="delete"
                                flat
                                round
                                @click="removeCounter(index)"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </QCardMain>

        <QCardActions class="justify-end">
            <publish-button :model="model" what="achievement"/>

            <q-btn
                v-if="!published"
                icon="delete"
                flat
                round
                @click="emitRemove"
            />
        </QCardActions>
    </q-card>
</template>

<script>
    import DropArea from './DropArea'
    import ImageViewer from './pole/viewers/ImageViewer'
    import PublishButton from './pole/PublishButton'

    export default {
        data () {
            return {
                counters: [],
                removedCounters: [],
            }
        },
        name: 'AchievementItem',
        components: {PublishButton, DropArea, ImageViewer},
        props: ['model'],
        methods: {
            emitRemove () {
                this.$store.dispatch('remove', {
                    what: 'achievement',
                    id: this.model.achievementId
                })
            },
            setThumbUrl (e) {
                this.model.thumbUrl = JSON.parse(e.dataTransfer.getData('text')).urlPath
            },
            addCounter () {
                this.counters = [
                    ...this.counters, {
                        id: '',
                        value: 0,
                    }]
            },
            updateCounters () {
                this.model.counterThresholds = this.counters.filter(({id, value}) => id && value > 0).
                    reduce((p, c) => ({
                        ...p,
                        [c.id]: c.value,
                    }), {})
            },
            removeCounter (index) {
                this.counters = this.counters.filter((_, idx) => index !== idx)
                this.updateCounters()
            },
        },
        mounted () {

        },
        watch: {
            counters () {

            },
            existingCounters (counterThresholds) {
                if (! counterThresholds) {
                    this.counters = [];
                    return;
                }

                if (this.counters.length > 0) {
                    return
                }

                const keys = Object.keys(counterThresholds)
                this.counters = keys.map(key => {
                    return {
                        id: key,
                        value: counterThresholds[key],
                    }
                })
            },
        },
        computed: {
            published () {
                return this.model.publicationInformation && this.model.publicationInformation.status !== 'Unpublished'
            },
            allCounters () {
                return [
                    ...this.$store.getters.badge.map(({badgeId, label}) => ({
                        value: `BADGE_${badgeId}`,
                        label: `Odz. ${label}`,
                    })),
                    {
                        value: 'STEPOMETER',
                        label: 'Krokomierz',
                    },
                    {
                        value: 'DAYS_IN_ROW',
                        label: 'Ciągłe użycie',
                    },
                ]
            },
            existingCounters () {
                return this.model.counterThresholds
            },
        },
    }
</script>

<style scoped lang="scss">
    .main {
        border-radius: 20px;
        /*height: 350px;*/
        margin-top: 20px;

        &:first-child {
            margin-top: 0;
        }
    }
</style>